import type { FC } from 'react';

import { Icon, type IconName } from '@iconik-io/uad';

import styles from './asset_status_icon.module.css';

const STATUS_QUEUED = 'QUEUED';
const STATUS_PREPARED = 'PREPARED';
const STATUS_INPROGRESS = 'INPROGRESS';
const STATUS_UPLOADED = 'UPLOADED';
const STATUS_ERROR = 'ERROR';

const STATUS_WAITING = 'WAITING';
const STATUS_STARTED = 'STARTED';
const STATUS_FINISHED = 'FINISHED';

const STATUS_REQUESTED = 'REQUESTED';
const STATUS_DONE = 'DONE';
const STATUS_FAILED = 'FAILED';

type StatusIconProps = {
  status: string;
  name: IconName;
};

const StatusIcon: FC<StatusIconProps> = (props) => {
  let statusClassName = styles.root;

  switch (props.status) {
    case STATUS_WAITING:
    case STATUS_QUEUED:
    case STATUS_PREPARED:
      statusClassName = styles.root_blue;
      break;
    case STATUS_REQUESTED:
      statusClassName = styles.root_yellow;
      break;
    case STATUS_INPROGRESS:
    case STATUS_UPLOADED:
    case STATUS_DONE:
    case STATUS_STARTED:
    case STATUS_FINISHED:
      statusClassName = styles.root_green;
      break;
    case STATUS_ERROR:
    case STATUS_FAILED:
      statusClassName = styles.root_red;
      break;
    default:
      return null;
  }

  return (
    <div className={statusClassName}>
      <Icon name={props.name} className={styles.icon} />
    </div>
  );
};

export default StatusIcon;

type IconProps = {
  status: string;
};

export const AssetUploadIcon: FC<IconProps> = (props) => (
  <StatusIcon {...props} name="load_up" />
);

export const AssetTranscodeIcon: FC<IconProps> = (props) => (
  <StatusIcon {...props} name="transcoder" />
);

export const AnalyzeStatusIcon: FC<IconProps> = (props) => (
  <StatusIcon {...props} name="analyze" />
);
